const select = {
  select:'Вибрати',
  placeholder:'Виберіть елемент',
};
export default select;
